import { Link } from "react-router-dom";

//Styles
import { Wrapper, Content, LogoImg, TMDBLogoImg } from "./Header.styles";

// import RMDBLogo from "../../image/logo.svg";
import RLogo from "../../image/logo.svg";

const Header = () => (
    <Wrapper>
        <Content>
            <Link to="/">
                <LogoImg src={RLogo} alt="react-logo" />
            </Link>
            <TMDBLogoImg
                src="https://www.themoviedb.org/assets/2/v4/logos/v2/blue_square_2-d537fb228cf3ded904ef09b136fe3fec72548ebc1fea3fbbd1ad9e36364db38b.svg"
                alt="tmdb-logo"
            />
        </Content>
    </Wrapper>
);
export default Header;
